import { useTranslations } from "@zapier/i18n";
import { EmptyTableDisplay, useRouterParams } from "@zapier/shared";
import { CHATBOT_CREATE_ROUTE } from "@zapier/utils";
import { ChatbotsEmptyState } from "@zapier/spark-ui";
import { useAccountActionPermissions } from "@zapier/client";

export enum EmptyChatbotsTableTypes {
  EmptySearchResults = "EmptySearchResults",
  NoSharedChatbots = "NoSharedChatbots",
  NoOwnedChatbots = "NoOwnedChatbots",
  NoChatbots = "NoChatbots",
}

interface Props {
  tableType: EmptyChatbotsTableTypes;
}

export function EmptyChatbotsTable({ tableType }: Props) {
  const t = useTranslations("chatbots-empty-table");

  const { clearFilterParams } = useRouterParams();

  const { isChatbotsEnabled } = useAccountActionPermissions();

  switch (tableType) {
    case EmptyChatbotsTableTypes.EmptySearchResults: {
      return (
        <EmptyTableDisplay
          actionButtonText={t("actions.clear-search")}
          headerText={t("search.no-results-header")}
          icon="navSearch"
          onActionButton={() => clearFilterParams()}
          subHeaderText={t("search.no-results-description")}
        />
      );
    }
    case EmptyChatbotsTableTypes.NoSharedChatbots: {
      return (
        <EmptyTableDisplay
          icon="navAIChatbot"
          headerText={t("shared.no-chatbots-header")}
          subHeaderText={t("shared.no-chatbots-description")}
        />
      );
    }
    case EmptyChatbotsTableTypes.NoOwnedChatbots: {
      return (
        <EmptyTableDisplay
          icon="navAIChatbot"
          headerText={t("owned.no-chatbots-header")}
          subHeaderText={t("owned.no-chatbots-description")}
          secondActionButtonHref={CHATBOT_CREATE_ROUTE}
          secondActionButtonText={t("actions.create-chatbot")}
          secondActionButtonIcon="formAdd"
          sectionActionButtonColor="secondary"
        />
      );
    }
    default: {
      return <ChatbotsEmptyState isDisabled={!isChatbotsEnabled} />;
    }
  }
}
